import { render, staticRenderFns } from "./HistoryManageDialog.vue?vue&type=template&id=2b8e5244&scoped=true"
import script from "./HistoryManageDialog.vue?vue&type=script&lang=ts"
export * from "./HistoryManageDialog.vue?vue&type=script&lang=ts"
import style0 from "./HistoryManageDialog.vue?vue&type=style&index=0&id=2b8e5244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e5244",
  null
  
)

export default component.exports